import { useState, useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { draftOrderService } from '../services/draftOrderService';

export function useDraftOrders() {
  const { currentAgent } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadOrders = async () => {
    if (!currentAgent?.agent_id) return;
    setLoading(true);
    setError(null);
    try {
      const data = await draftOrderService.getDraftOrders({
        role: currentAgent.role || 'user',
        agentId: currentAgent.agent_id,
      });
      setOrders(data);
    } catch (err) {
      setError(err.message || 'Failed to load draft orders.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadOrders();
  }, [currentAgent?.agent_id]);

  return { orders, loading, error, reload: loadOrders };
}

